@if (password()) {
  <div class="strength" role="status">
    <div class="strength__bar">
      <span
        class="strength__fill"
        [class.strength__fill--weak]="score() <= 2"
        [class.strength__fill--fair]="score() === 3"
        [class.strength__fill--good]="score() === 4"
        [class.strength__fill--strong]="score() === 5"
        [style.width.%]="(score() / rules().length) * 100"
      ></span>
    </div>
    <div class="strength__label" [class.strength__label--strong]="allMet()">{{ level() }}</div>

    <ul class="strength__rules">
      @for (rule of rules(); track rule.label) {
        <li [class.strength__rule--met]="rule.met">
          <span class="strength__rule-icon">{{ rule.met ? '✓' : '·' }}</span>
          {{ rule.label }}
        </li>
      }
    </ul>
  </div>
}
